import { MDSBreakpoints } from "@/mds/foundations";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { MDSLensGroupItemProps } from "@/mds/components/lens-group/lens-group.types";
import styled from "@emotion/styled";
import { useState } from "react";
import { Button } from "react-aria-components";
import { useMediaQuery } from "usehooks-ts";

export const MDSLensGroupItem = ({ label, onClick, isActive }: MDSLensGroupItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useMediaQuery(MDSBreakpoints.phone);

  return (
    <StyledButton
      onClick={() => onClick()}
      $isActive={isActive}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <TextWrapper $isActive={isActive}>
        <MDSText
          variant={isMobile ? MDSTextVariant.TextSm : MDSTextVariant.TextM}
          weight={MDSTextWeight.SemiBold}
          color={
            isActive
              ? MDSTextColor.Primary
              : isHovered
                ? MDSTextColor.Secondary
                : MDSTextColor.Tertiary
          }
        >
          {label}
        </MDSText>
      </TextWrapper>
    </StyledButton>
  );
};

const StyledButton = styled(Button)<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: ${({ theme }) => theme.spacing["2"]};
  padding-block: 0px;
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.text.primary : theme.colors.text.tertiary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};

  &[data-hovered]:not([data-disabled]) {
    color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.text.primary : theme.colors.text.tertiary};
  }
`;

const TextWrapper = styled.div<{ $isActive?: boolean }>`
  padding-block: 14px;
  border-bottom: ${({ $isActive, theme }) =>
    $isActive ? `4px solid ${theme.colors.background.activeTab}` : "4px solid transparent"};
`;
